'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spaTypes = exports.groupDestinationsByCountry = exports.groupDestinationsByRegion = exports.groupDestinationsByKey = exports.convertToDestinationArray = exports.sortByCities = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.getMeetingPoints = getMeetingPoints;
exports.getHour = getHour;
exports.hasBorder = hasBorder;
exports.getTransportation = getTransportation;
exports.getActivityIcon = getActivityIcon;
exports.getCondition = getCondition;
exports.getSupportedCurrencies = getSupportedCurrencies;
exports.isTripSupportThisCurrency = isTripSupportThisCurrency;
exports.decorateMultiTierPricesToQuantity = decorateMultiTierPricesToQuantity;
exports.getChildPriceObject = getChildPriceObject;
exports.decorateAdditionalOptionsString = decorateAdditionalOptionsString;
exports.hasTag = hasTag;
exports.calculateDuration = calculateDuration;
exports.calculateTripPrice = calculateTripPrice;
exports.calculateTripCost = calculateTripCost;
exports.checkNonTour = checkNonTour;
exports.checkTierAvailability = checkTierAvailability;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortByCities = exports.sortByCities = function sortByCities(a, b) {
  if (a.city === 'Bangkok') return -1;
  if (a.city < b.city) return -1;
  if (a.city > b.city) return 1;
  return 0;
};

var convertToDestinationArray = exports.convertToDestinationArray = function convertToDestinationArray(data) {
  var destinations = [];
  (0, _keys2.default)(data).map(function (key) {
    destinations = destinations.concat(data[key]);
  });
  return destinations;
};

var groupDestinationsByKey = exports.groupDestinationsByKey = function groupDestinationsByKey(key) {
  return function (props) {
    var messages = props.messages;

    var popular = props.destinations.filter(function (d) {
      return d.popular;
    });
    var cities = props.destinations.filter(function (d) {
      return !d.popular;
    }).reduce(function (prev, cur) {
      if (!prev[cur[key]]) {
        prev[cur[key]] = [];
      }
      prev[cur[key]].push(cur);
      return prev;
    }, {});
    popular.sort(sortByCities);
    (0, _keys2.default)(cities).map(function (k) {
      cities[k].sort(sortByCities);
    });
    var grouped = popular.length > 0 ? (0, _defineProperty3.default)({}, messages.popular_cities, popular) : {};
    return (0, _extends3.default)({}, grouped, cities);
  };
};

var groupDestinationsByRegion = exports.groupDestinationsByRegion = groupDestinationsByKey('region');
var groupDestinationsByCountry = exports.groupDestinationsByCountry = groupDestinationsByKey('country');

function getMeetingPoints() {
  var meetingPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return _lodash2.default.values(meetingPoints.reduce(function (prev, cur) {
    if (prev[cur.icon_name]) {
      prev[cur.icon_name].text += ', ' + cur.name;
    } else {
      prev[cur.icon_name] = {
        data: cur,
        type: cur.type,
        icon_name: cur.icon_name,
        text: cur.name
      };
    }
    return prev;
  }, {}));
}

function getHour(hour) {
  if (hour && hour.split(' ')) {
    return hour.split(' ')[0];
  }
  return null;
}

function hasBorder(i, l) {
  if (l % 3 === 0) {
    return i < l - 3;
  }
  return i < l - l % 3;
}

function getTransportation(trans) {
  switch (trans) {
    case 'Private Car':
      return { standard: true, id: 'trip.item.private_car' };
    case 'Private Motorcycle':
      return { standard: true, id: 'trip.item.private_motorcycle' };
    case 'Private Van':
      return { standard: true, id: 'trip.item.private_van' };
    case 'Private Jet Ski':
      return { standard: true, id: 'trip.item.private_jet_ski' };
    case 'Private Bike':
      return { standard: true, id: 'trip.item.private_bike' };
    case 'Private ATV':
      return { standard: true, id: 'trip.item.private_atv' };
    case 'Public Transportation':
      return { standard: true, id: 'trip.item.public_transportation' };
    default:
      return { standard: false, id: trans };
  }
}

function getActivityIcon(activity) {
  if (activity === 'Bazaar' || activity === 'ตลาดนัดถาวร' || activity === '大集市') {
    return 'bazaar';
  }
  if (activity === 'Floating Market' || activity === 'ตลาดน้ำ' || activity === '水上市场') {
    return 'floating-market';
  }
  if (activity === 'Fresh Market' || activity === 'ตลาดสด' || activity === '菜场') {
    return 'fresh-market';
  }
  if (activity === 'Flea Market' || activity === 'ตลาดนัด' || activity === '平价集市') {
    return 'flea-market';
  }
  if (activity === 'Cafe' || activity === 'ร้านกาแฟ' || activity === '咖啡店') {
    return 'cafe';
  }
  if (activity === 'Cooking Class' || activity === 'เรียนทำอาหาร' || activity === '烹饪班') {
    return 'cooking-class';
  }
  if (activity === 'Restaurants' || activity === 'ร้านอาหาร' || activity === '餐厅') {
    return 'restaurants';
  }
  if (activity === 'Street Food' || activity === 'อาหารริมทาง' || activity === '路边小吃') {
    return 'street-food';
  }
  if (activity === 'Adventure' || activity === 'ผจญภัย' || activity === '冒险') {
    return 'adventure';
  }
  if (activity === 'Boating' || activity === 'นั่งเรือ' || activity === '划船') {
    return 'boating';
  }
  if (activity === 'Boxing' || activity === 'ต่อยมวย' || activity === '拳击') {
    return 'boxing';
  }
  if (activity === 'City Tour' || activity === 'ชมเมือง' || activity === '城市游') {
    return 'city-tour';
  }
  if (activity === 'Cycling' || activity === 'ปั่นจักรยาน' || activity === '自行车骑行') {
    return 'cycling';
  }
  if (activity === 'Beach & Island' || activity === 'ชายหาดและเกาะ' || activity === '海滩&岛屿') {
    return 'beach-n-island';
  }
  if (activity === 'Botanic Garden' || activity === 'สวน' || activity === '花园') {
    return 'botanic-garden';
  }
  if (activity === 'Safari' || activity === 'ซาฟารี ส่องสัตว์' || activity === '动物') {
    return 'safari';
  }
  if (activity === 'Farming') {
    return 'farming';
  }
  if (activity === 'Trekking & Hiking' || activity === 'เดินป่าและปีนเขา' || activity === '走路&爬山') {
    return 'trekking-n-hiking';
  }
  if (activity === 'Waterfall' || activity === 'น้ำตก' || activity === '瀑布') {
    return 'waterfall';
  }
  if (activity === 'Water Activities' || activity === 'กิจกรรมทางน้ำ' || activity === '水上活动') {
    return 'water-activities';
  }
  if (activity === 'Local Wisdom & Living' || activity === 'ภูมิปัญญาท้องถิ่น' || activity === '当地智慧与生活') {
    return 'local-wisdom-n-living';
  }
  if (activity === 'Volunteering' || activity === 'อาสาสมัคร' || activity === '志愿者') {
    return 'volunteering';
  }
  if (activity === 'Art Exhibition' || activity === 'การแสดงศิลปะ' || activity === '艺术展览') {
    return 'art-exhibition';
  }
  if (activity === 'Crafting' || activity === 'หัตถกรรม' || activity === '手工') {
    return 'crafting';
  }
  if (activity === 'Drinking' || activity === 'ท่องราตรี' || activity === '饮料') {
    return 'drinking';
  }
  if (activity === 'History & Culture' || activity === 'ประวัติศาสตร์และวัฒนธรรม' || activity === '历史与文化') {
    return 'history-n-culture';
  }
  if (activity === 'Massage & Spa' || activity === 'สปาและการนวด' || activity === '按摩&SPA') {
    return 'massage-n-spa';
  }
  if (activity === 'Spiritual' || activity === 'จิตวิญญาณ' || activity === '宗教信仰') {
    return 'spiritual';
  }
}

function getCondition(condition) {
  switch (condition) {
    case 'smartCasual':
      return {
        icon: 'smart-casual'
      };
    case 'physical':
      return {
        icon: 'physical-strength'
      };
    case 'vegetarian':
      return {
        icon: 'vegeterian-food'
      };
    case 'children':
      return {
        icon: 'children-friendly'
      };
    case 'flexible':
      return {
        icon: 'flexible-plan'
      };
    case 'seasonal':
      return {
        icon: 'seasonal-activity'
      };
    default:
      return {
        icon: ''
      };
  }
}

function getSupportedCurrencies(trip) {
  var currencies = [];
  currencies.push(trip.lx_currency || 'THB');
  if (trip.foreign_prices) {
    (0, _keys2.default)(trip.foreign_prices).forEach(function (cur) {
      if (currencies.indexOf(cur) === -1) currencies.push(cur);
    });
  }
  return currencies;
}

function isTripSupportThisCurrency(trip, currency) {
  var supportedCurrencies = getSupportedCurrencies(trip);
  return supportedCurrencies.indexOf(currency) !== -1;
}

function decorateMultiTierPricesToQuantity(multiTierPrices) {
  return multiTierPrices.reduce(function (acc, curr) {
    return [].concat((0, _toConsumableArray3.default)(acc), [(0, _extends3.default)({}, curr, {
      tier: curr.tier,
      sub_tiers: curr.sub_tiers.map(function (sub) {
        return (0, _extends3.default)({}, sub, { quantity: 0 });
      })
    })]);
  }, []);
}

function getChildPriceObject(additionalOptions, sessionData) {
  var childPriceObj = void 0;
  additionalOptions.forEach(function (option) {
    if (option.type === 'child_price' && option.currency === sessionData.currency) {
      childPriceObj = option;
    }
  });
  return childPriceObj;
}

function decorateAdditionalOptionsString(obj) {
  if ((0, _keys2.default)(obj).length === 0) return '';
  // let optionsString = '';
  return (0, _keys2.default)(obj).map(function (key) {
    return key + ':' + obj[key];
  }).join(',');
  // if (obj.childQuantity > 0) {
  //   optionsString += `children:${obj.childQuantity}`;
  // }
  // if (optionsString === '') return '';
  // return `options=${optionsString}`;
}

function hasTag(trip, searchTag) {
  if (!trip.tags) return false;
  return trip.tags.find(function (tag) {
    return tag === searchTag;
  }) !== undefined;
}

var spaTypes = exports.spaTypes = ['Thai Body Massage', 'Foot Massage', 'Head-Back-Shoulder Massage'];

function calculateDuration(matchStart, matchEnd) {
  return +matchEnd[1] === +matchStart[1] ? 3 : (+matchEnd[1] - +matchStart[1] + 24) % 24;
}

function calculateTripPrice(defaultPrice, quantity, isAgency) {
  var travelAgencyCommission = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var price = 0;
  var pricePerson = 0;
  if (defaultPrice) {
    if (isAgency) {
      pricePerson = Math.floor(defaultPrice - defaultPrice * travelAgencyCommission);
    } else {
      pricePerson = defaultPrice;
    }
    price = pricePerson * quantity;
  }
  return price;
}

function calculateTripCost(defaultPrice, isAgency) {
  var travelAgencyCommission = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var price = 0;
  var percent = 0;
  if (defaultPrice) {
    if (isAgency) {
      percent = travelAgencyCommission / (1 - travelAgencyCommission);
    }
    price = defaultPrice + defaultPrice * percent;
  }
  return Math.ceil(price);
}

function checkNonTour(trip) {
  // Note: Technically, it's used for the review process
  return trip.product_type !== 'trip' || ['5c0fa974bc1c330011ec5e8b', '5d1daadec6844d00164b3c31'].includes(trip._id.toString()) // Tuk Tuk hop
  ;
}

function checkTierAvailability(multiTier, date) {
  if (!!multiTier.unavailable_dates && multiTier.unavailable_dates.length > 0) {
    return multiTier.unavailable_dates.every(function (data) {
      var res = true;
      if (!!data.from && !!data.to) {
        res = !(0, _momentTimezone2.default)(date).isBetween(data.from, data.to, null, '[]');
      } else if (!!data.from) {
        res = !(0, _momentTimezone2.default)(date).isSameOrAfter(data.from);
      } else if (!!data.to) {
        res = !(0, _momentTimezone2.default)(date).isSameOrBefore(data.to);
      }
      return res;
    });
  }
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/trip.js
// module id = 38
// module chunks = 47